import React from 'react'
import { Tabs } from 'antd'
import CommonTablePage from '../../../components/common/common-table/common-table-page'
import CustomerGroup1ManagementColumnModel from '../small-group-management-pages/customer-group1-management-page/customer-group1-management-column-model'
import CustomerGroup2ManagementColumnModel from '../small-group-management-pages/customer-group2-management-page/customer-group2-management-column-model'
import CustomerGroup3ManagementColumnModel from '../small-group-management-pages/customer-group3-management-page/customer-group3-management-column-model'
import CustomerGroup4ManagementColumnModel from '../small-group-management-pages/customer-group4-management-page/customer-group4-management-column-model'
import CustomerGroup5ManagementColumnModel from '../small-group-management-pages/customer-group5-management-page/customer-group5-management-column-model'
import { urlKey } from '../../../services/api/api-urls'
import { useDocumentTitle } from '../../../services/title/useDocumentTitle'

const { TabPane } = Tabs

const CustomerGroupManagementPage = () => {
  useDocumentTitle()

  return (
    <div>
      <Tabs defaultActiveKey="1">
        <TabPane tab="Group 1" key="1">
          <CommonTablePage
            urlInfoKey={urlKey.CustomerGroup1}
            title="Customer Group 1"
            column={CustomerGroup1ManagementColumnModel.CustomerGroup1ManagementColumn}
            mappingUpdateData={(dataDetail: any, type: any) => {
              dataDetail.priceVisible = parseInt(dataDetail.priceVisible)
              return dataDetail
            }}
          />
        </TabPane>
        <TabPane tab="Group 2" key="2">
          <CommonTablePage
            urlInfoKey={urlKey.CustomerGroup2}
            title="Customer Group 2"
            column={CustomerGroup2ManagementColumnModel.CustomerGroup2ManagementColumn}
          />
        </TabPane>
        <TabPane tab="Group 3" key="3">
          <CommonTablePage
            urlInfoKey={urlKey.CustomerGroup3}
            title="Customer Group 3"
            column={CustomerGroup3ManagementColumnModel.CustomerGroup3ManagementColumn}
          />
        </TabPane>
        <TabPane tab="Group 4" key="4">
          <CommonTablePage
            urlInfoKey={urlKey.CustomerGroup4}
            title="Customer Group 4"
            column={CustomerGroup4ManagementColumnModel.CustomerGroup4ManagementColumn}
          />
        </TabPane>
        <TabPane tab="Group 5" key="5">
          <CommonTablePage
            urlInfoKey={urlKey.CustomerGroup5}
            title="Customer Group 5"
            column={CustomerGroup5ManagementColumnModel.CustomerGroup5ManagementColumn}
          />
        </TabPane>
      </Tabs>
    </div>
  )
}

export default CustomerGroupManagementPage
